"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FilterCategory;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _radio = _interopRequireDefault(require("@ux/radio"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const CategoryListContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "CategoryListContainer",
  class: "pl-c9o6spv"
});
function FilterCategory({
  categoryList,
  categoryCounts,
  handleCategorySelection,
  radioProps
}) {
  return /*#__PURE__*/_react.default.createElement(CategoryListContainer, {
    "data-cy": "category-list-container"
  }, categoryList && categoryList.map(({
    id,
    name,
    ...category
  }) => /*#__PURE__*/_react.default.createElement(_radio.default, (0, _extends2.default)({
    key: `category-${id}`,
    id: `category-${id}`,
    "data-cy": `category-item`,
    label: `${name} (${categoryCounts[id]})`,
    onChange: handleCategorySelection(id),
    name: 'category-selector'
  }, category, radioProps))));
}
FilterCategory.propTypes = {
  handleCategorySelection: _propTypes.default.func,
  categoryCounts: _propTypes.default.object,
  categoryList: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string,
    value: _propTypes.default.string,
    id: _propTypes.default.number,
    name: _propTypes.default.string,
    checked: _propTypes.default.bool
  })),
  radioProps: _propTypes.default.shape(_radio.default.propTypes)
};